import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(text: string, stringToFind: string | RegExp, replacementString: string): string {
    let newString = text ? text : '';
    if (stringToFind) {
      newString = newString.replace(stringToFind, replacementString ? replacementString : '');
    }
    return newString;
  }

}
